import { render } from "./DuplicateVersionDialog.vue?vue&type=template&id=858b38ea&scoped=true"
import script from "./DuplicateVersionDialog.vue?vue&type=script&lang=js"
export * from "./DuplicateVersionDialog.vue?vue&type=script&lang=js"

import "./DuplicateVersionDialog.vue?vue&type=style&index=0&id=858b38ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-858b38ea"]])

export default __exports__